import React from "react";
import Tree from "react-d3-tree";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HierarchicalChart.css";

function HierarchicalChart() {
  const orgChart = {
    name: "CEO",
    children: [
      {
        name: "MES",
        children: [
          {
            name: "DFS",
            children: [{ name: "EDS" }, { name: "IAS" }, { name: "BIM" }],
          },
        ],
      },
      {
        name: "OD",
        children: [{ name: "TAG", children: [{ name: "HR" }] }],
      },
      {
        name: "ITE",
        children: [
          {
            name: "HR Manager",
            children: [{ name: "Recruiters" }, { name: "Payroll Specialists" }],
          },
          {
            name: "Operations Manager",
            children: [{ name: "Administrative Staff" }],
          },
        ],
      },
    ],
  };

  return (
    <div className="hierarchical-container">
      <div className="tree-wrapper">
        <Tree
          data={orgChart}
          orientation="vertical"
          translate={{ x: window.innerWidth / 2.2, y: 100 }}
          zoom={1}
          nodeSvgShape={{
            shape: "circle",
            shapeProps: {
              r: 15,
              fill: "#7564e6",
              stroke: "#7564e6",
              strokeWidth: 2,
            },
          }}
          styles={{
            nodes: {
              node: {
                name: {
                  fill: "#7564e6",
                  fontSize: "13px",
                  fontWeight: "600",
                },
              },
              leafNode: {
                name: {
                  fill: "#7564e6",
                  fontSize: "12px",
                  fontWeight: "500",
                },
              },
            },
            links: {
              stroke: "#7564e6",
              strokeWidth: 2,
            },
          }}
        />
      </div>
    </div>
  );
}

export default HierarchicalChart;
